export default __webpack_public_path__ + "static/media/right-arrow-color.eca4a359.svg";